// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".update_ctn[data-v-7304a192]{height:100%;text-align:center;position:relative;line-height:50px}.update_ctn .center[data-v-7304a192]{position:absolute;left:50%;top:50%;transform:translate(-50%,-50%)}.update_ctn .center img[data-v-7304a192]{width:320px}", ""]);
// Exports
module.exports = exports;
